<template>
  <slot v-bind="{ valid }" />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'

let form: HTMLFormElement | null
let fields: Array<HTMLInputElement | HTMLTextAreaElement> = []

const valid = ref(false)

// const sendAjax = async () => {
//   if (!form) {
//     return
//   }
//   const url = String(form.getAttribute('action'))
//   const method = form.getAttribute('method') || 'post'
//   const body = new FormData(form)
//   const res = await fetch(url, {
//     method,
//     body,
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//       'Accept': 'application/json'
//     }
//   })
//   const data = await res.json()
//   console.log(res, data)
// }

const handleSubmit = async (e: Event) => {
  if (!validate()) {
    e.preventDefault()
    // window.Shopify.captcha.protect(form, () => setTimeout(sendAjax, 300))
  }
}

const validate = () => {
  return valid.value = fields.every((field) => field.value.trim().length)
}

onMounted(() => {
  form = document.getElementById('contact_form') as HTMLFormElement
  if (!form) {
    return
  }
  form.addEventListener('submit', handleSubmit)
  fields = Array.from(form.querySelectorAll('input[required], textarea[required]'))
  fields.forEach(field => field.addEventListener('input', validate))
  validate()
})

onBeforeUnmount(() => {
  fields.forEach(field => field.removeEventListener('input', validate))
})
</script>
